/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum PlanningPeriod {
    Daily = 0,
    Weekly = 1,
    Monthly = 2,
    Quarterly = 3,
}
